import _ from 'lodash';
import { cognito } from 'react-cognito';
import { combineReducers } from 'redux';
import { Map } from 'immutable';
import dotProp from 'dot-prop-immutable';

let selectedAppartment = null;
let selectedRoom = null;

// if(typeof document != "undefined" && document.location.hash) {
//     let hash = document.location.hash.substr(1, document.location.hash.length-1);
//     hash = hash.split('-');

//     if(hash[0]) selectedAppartment = hash[0];
//     if(hash[1]) selectedRoom = hash[1];
// }
// else {
//     selectedAppartment = null;
//     selectedRoom = null;
// }

const initialState = {
    selectedAppartment,
    selectedRoom,
    rootClassEffect: 'fadein',
    displayHand: true,
    mode: 'video',
    selectedVideo: null,
    videos: [],
    appartments: [],
    texts: [],
    tables: {},
    buckets: {}
}

const app = (state = initialState, action) => {
    let st = Map(state);
    console.log(action)
    switch (action.type) {
        case 'CHANGE_VIGNETTE_URL':
            if(action.mode === '360') {
                let indexAppartment = _.findIndex(state.appartments, { Id: action.appartment });
                console.log(state, indexAppartment);

                console.log(action.appartment, action.room)

                if(typeof action.room === 'undefined') {
                    console.log(action.url)

                    console.log(indexAppartment)

                    st = dotProp.set(st.toJS(), 'appartments.' + indexAppartment + '.VignetteUrl', action.url)
                }
                else {
                    let indexRoom = _.findIndex(state.appartments[indexAppartment].Rooms, { Id: action.room });

                    st = dotProp.set(st.toJS(), 'appartments.' + indexAppartment + '.Rooms.' + indexRoom + '.VignetteUrl', action.url )
                }
            }

            if(action.mode === 'videos') {
                let indexVideo = _.findIndex(state.videos, { Id: action.video });

                st = dotProp.set(st.toJS(), 'videos.' + indexVideo + '.VignetteUrl', action.url )
            }

            return st;

        case 'CHOOSE_APPARTMENT':
            let appartEntity = _.find(state.appartments, { id: action.appartmentId });

            st = st.set('selectedAppartment', action.appartmentId)
            st = st.set('selectedRoom', appartEntity.default_room)
            st = st.set('displayHand', true)

            return st.toJS();

        case 'CHANGE_ROOM':
            st = st.set('selectedAppartment', action.appartmentId)
            st = st.set('selectedRoom', action.roomId)
            st = st.set('displayHand', true)

            return st.toJS();

        case 'BACK':
            st = st.set('selectedAppartment', null);
            st = st.set('selectedRoom', null);

            return st.toJS();

        case 'HIDE_HAND':
            st = st.set('displayHand', false)

            return st.toJS();

        case 'SELECT_MODE_360':
            st = st.set('mode', '360')

            return st.toJS();

        case 'SELECT_MODE_VIDEO':
            st = st.set('mode', 'video')

            return st.toJS();

        case 'CHANGE_VIDEO':
            st = st.set('selectedVideo', action.videoId);

            return st.toJS();

        case 'CHANGE_TEXTS_VIDEOAPP':
            st = st.set('line1', action.line1);
            st = st.set('line2', action.line2);

            return st.toJS();

        case 'PAGE_CHANGE_START':
            st = st.set('rootClassEffect', 'fadeout');

            return st.toJS();

        case 'PAGE_CHANGE_END':
            st = st.set('rootClassEffect', 'fadein');

            return st.toJS();

        case 'RETRIEVE_APPARTMENTS_RESPONSE':
            st = st.set('appartments', _.orderBy(action.response, [ 'Order' ], [ 'asc' ]) );

            return st.toJS();

        case 'RETRIEVE_VIDEOS_RESPONSE':
            st = st.set('videos', _.orderBy(action.response, [ 'Order' ], [ 'asc' ]));

            return st.toJS();

        case 'RETRIEVE_TEXTS_RESPONSE':
            st = st.set('texts', action.response);

            return st.toJS();

        case 'CHANGE_TEXT':
            let txtIndex = _.findIndex(state.texts, { Key: action.key })
            if(txtIndex !== -1) {
                st = dotProp.set(st.toJS(), 'texts.' + txtIndex + '.Value', action.newValue)
            }

            return st;

        case 'CHANGE_360_IFRAME':
            let appartmentIndex = _.findIndex(state.appartments, { Id: action.appartmentId })
            let roomIndex = _.findIndex(state.appartments[appartmentIndex].Rooms, { Id: action.roomId })

            st = dotProp.set(st.toJS(), 'appartments.' + appartmentIndex + '.Rooms.' + roomIndex + '.IframeUrl', action.newValue)

            return st;

        case 'CHANGE_VIDEO_YTID':
            let videoIndex = _.findIndex(state.videos, { Id: action.videoId })

            st = dotProp.set(st.toJS(), 'videos.' + videoIndex + '.VideoId', action.newValue)

            return st;

        case 'CHANGE_VIDEO_END_SECONDS':
            let videoIndexx = _.findIndex(state.videos, { Id: action.videoId })

            st = dotProp.set(st.toJS(), 'videos.' + videoIndexx + '.VideoEndSeconds', action.newValue)

            return st;

        case 'CONFIGURE_RESOURCES':
            st = st.set('tables', action.tables);
            st = st.set('buckets', action.buckets);

            console.log(st.toJS())

            return st.toJS();


        default:
            return st.toJS();
    }
}

export default combineReducers({
    app,
    cognito
})



// WEBPACK FOOTER //
// ./src/reducers/index.js